import {formatTime2Arr} from 'hiya-common/src/utils'
import {HiyaVerHost} from 'hiya-common/src/constant'
import {channel_type_enum} from 'hiya-common/src/reducers/commonTypes'

export const markNum = (num) => {
  if (num === 0) {
    return 0
  }
  return num < 0 ? num : `+${Math.abs(num)}`
}
export const getSecTime = (sec) => {
  return formatTime2Arr(Number(sec) || 0, false)
}

export const getHoursMin = (sec) => {
  if (!sec) {
    return '0min'
  }
  if (sec > 60 && sec < 3600) {
    return `${Math.floor(sec / 60)}min`
  }
  if (sec > 3600) {
    return Math.floor((sec % 3600) / 60) > 0
      ? `${Math.floor(sec / 3600)}h${Math.floor((sec % 3600) / 60)}min`
      : `${Math.floor(sec / 3600)}h`
  }
  return '0min'
}
// 账目类型
export enum DiamondAndSalaryKind {
  退款 = 1,
  回款 = 2,
}
// 钻石和薪资下退款和再充值tab数据是一样的，只是一个展示的是钻石一个是美元
export enum RefundAndRepayTab {
  钻石 = 1, // 1追回钻石列表
  薪资 = 2, // 2追回薪资列表
}

export const ColorType = {
  diamond: {
    [DiamondAndSalaryKind.退款]: 'orange',
    [DiamondAndSalaryKind.回款]: 'blue',
  },
  salary: {
    [DiamondAndSalaryKind.退款]: 'red',
    [DiamondAndSalaryKind.回款]: 'green',
  },
}

export const goRefundDetail = (params: {
  order_id: string
  id: number
  mid: number
  t_range: string
  kind: RefundAndRepayTab
}) => {
  const url = `${HiyaVerHost}/anchorcenter/RefundDetail`
  // otherInfo中必须包含order_id:string id:number mid:number  t_range:string kind

  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
      JSON.stringify(params)
    )}&url=${url}`,
  })
}

export const goRefundList = (params: {mid?: number}) => {
  const url = `${HiyaVerHost}/anchorcenter/RefundList`
  // otherInfo中可以不包含mid 没有mid就使用deviceinfo中的h_m
  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
      JSON.stringify(params)
    )}&url=${url}`,
  })
}
// 去往薪资钱包
export const goSalaryWallet = () => {
  const url = `${HiyaVerHost}/union/SalaryWallet`
  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=1&external=0&need_user_info=1&url=${url}`,
  })
}

// 收款渠道中 不允许用户自助选中的渠道
export const noSelPayPaths = [
  channel_type_enum.转金币,
  channel_type_enum.转币商金币,
]
